import { render, staticRenderFns } from "./MainDrawerItem.vue?vue&type=template&id=1826afbc&scoped=true"
import script from "./mainDrawerItem.ts?vue&type=script&lang=ts&external"
export * from "./mainDrawerItem.ts?vue&type=script&lang=ts&external"
import style0 from "./MainDrawerItem.vue?vue&type=style&index=0&id=1826afbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1826afbc",
  null
  
)

export default component.exports